export default __webpack_public_path__ + "static/media/1280x720.d546abcc.svg";